import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import theme from '@/theme';
import styled from '@emotion/styled';
import { VoiceModelDropdown } from './VoiceModelSelection';

const VoiceModelControlContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    gap: 4px;
    border: ${theme.colors.black[200]} 1px solid;
    border-radius: 8px;
`;

const Text = styled.div`
    white-space: nowrap;
    font-size: 1.4rem;
    min-width: 130px;
`;

interface Props {
    value: string;
    setValue: (value: string) => void;
}

export const VoiceModelControl = ({ value, setValue }: Props) => {
    const [ttsSelectedVoice] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.ttsSelectedVoice);

    if (!ttsSelectedVoice?.config?.availableModels?.length) {
        return null;
    }

    return (
        <VoiceModelControlContainer>
            <Text>Voice Model</Text>
            <VoiceModelDropdown
                options={ttsSelectedVoice.config?.availableModels ?? [ttsSelectedVoice.config?.modelId!]}
                selected={value}
                onChange={setValue}
            />
        </VoiceModelControlContainer>
    );
};
